import React from "react";
import styled from "styled-components";
import { styles } from "../../styles";
import { useTranslation } from "react-i18next";

const FooterContainer = styled.ul`
  position: absolute;
  bottom: 16px;
  left: 23px;
  z-index: 6;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  margin: 0;

  li {
    list-style-type: none;

    & + li {
      margin-left: 0.6rem;

      &::before {
        content: "|";
        font-size: ${13 / 16}rem;
        line-height: ${11 / 16}rem;
        margin-right: 0.6rem;
        color: ${styles.colors.darkBlue75};
      }
    }

    a {
      font-size: ${11 / 16}rem;
      line-height: ${22 / 16}rem;
      color: ${styles.colors.darkBlue75};
      text-decoration: none;
      transition: color 0.1s ease;
    }

    a:hover {
      color: ${styles.colors.darkBlue};
    }

    @media screen and (pointer: coarse) {
      bottom: 10px;
      left: 16px;

      a {
        font-size: ${14 / 16}rem;
        line-height: ${22 / 16}rem;
      }
    }
  }
`;

export const ViewerFooter = () => {
  const { t } = useTranslation() as any;
  const privacyPolicyUrl = t("viewer.privacyPolicyUrl");
  const privacyPolicyLink = (privacyPolicyUrl && privacyPolicyUrl !== "viewer.privacyPolicyUrl") && (
    (
      <li>
        <a href={privacyPolicyUrl} target="_blank" rel="noreferrer noopener">
          {t('viewer.privacyPolicyText')}
        </a>
      </li>
    )
  );

  const cookiePolicyUrl = t("viewer.cookiePolicyUrl");
  const cookiePolicyLink = (cookiePolicyUrl && cookiePolicyUrl !== "viewer.cookiePolicyUrl") && (
    (
      <li>
        <a href={cookiePolicyUrl} target="_blank" rel="noreferrer noopener">
          {t('viewer.cookiePolicyText')}
        </a>
      </li>
    )
  );

  return (
    <FooterContainer>
      <li>
        <a href="https://poppr.be/en" target="_blank" rel="noreferrer noopener">
          {"Powered by "}
          <strong>Poppr</strong>
        </a>
      </li>
      {privacyPolicyLink}
      {cookiePolicyLink}
    </FooterContainer>
  );
};
